import { withStyles } from '@material-ui/core';

const styles = withStyles((theme) => ({
  paper: {
    margin: '0 auto',
    borderRadius: 4,

    '& .title': {
      fontWeight: 'bold',
      fontSize: 22,
      marginBottom: 8,
    },

    '& .subtitle': {
      fontSize: 18,
      marginBottom: 22,
    },

    '& .uncompleted-message': {
      color: '#dc3f53',
      marginTop: 8,
    },

    '& .text': {
      fontWeight: 400,
      fontSize: 16,
      marginBottom: 16,
      color: '#546E7A',
    },

    '& .price': {
      color: '#4CAF50',
      margin: '8px 0 0',
    },

    '& .details-container': {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        textAlign: 'center',
      },

      '& .image': {
        width: 115,
        height: 115,
        objectFit: 'cover',
        objectPosition: 'center',
        borderRadius: 4,
        display: 'block',
        [theme.breakpoints.down('sm')]: {
          width: 200,
          height: 200,
          display: 'inline',
        },
      },

      '& > .info': {
        maxWidth: 600,
        padding: '0 16px',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
          padding: '16px 0',
        },
      },

      '& small': {
        marginBottom: 8,
      },
    },

    '& .links-container': {
      margin: '36px 0',

      '& > strong': {
        display: 'block',
        marginBottom: 16,
      },

      '& table': {
        marginTop: 16,
        width: '100%',
        padding: 8,
        backgroundColor: '#F5F5F5',
        maxWidth: '100vw',
      },

      '& th': {
        fontWeight: 'normal',
        textAlign: 'left',
        paddingBottom: 8,
      },

      '& td': {
        padding: '0 8px',
      },

      '& tbody tr': {
        backgroundColor: '#FFF',
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },

    '& .mobile-container': {
      marginTop: 32,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,

      '& > div': {
        flexGrow: 1,
      },
    },

    '& .new-variation': {
      width: '100%',
      marginTop: 16,
      padding: 16,
      fontWeight: 'normal',
      border: 'dashed 2px #f0f0f0',
    },

    '& .card-more': {
      padding: 16,
      display: 'flex',
      gap: 16,
      flexDirection: 'column',
      border: 'thin solid #f0f0f0',
    },

    '& .footer': {
      paddingTop: 16,
      marginTop: 16,
      borderTop: 'thin solid #f0f0f0',
      [theme.breakpoints.down('sm')]: {
        '& > div': {
          flexGrow: 1,
        },
        '& a': { display: 'flex' },
        '& button': { flexGrow: 1 },
      },
    },
  },
  buttonDisabled: {
    opacity: 0.4,
  },
}));

export default styles;
